// components/MeetTheChef.tsx
import { useState, useEffect } from "react";
import person from "../../assets/person-white.png";

// Use 3 different images
import chef1 from "../../assets/chef1.jpeg";
import chef2 from "../../assets/chef2.jpeg";
import chef3 from "../../assets/chef3.jpeg";
import chef4 from "../../assets/chef4.jpeg";
// import chef5 from "../../assets/chef5.jpeg";
import chef6 from "../../assets/chef6.jpeg";

const images = [chef1, chef2, chef3, chef4, chef6];

export default function MeetTheChef() {
  const [activeIndex, setActiveIndex] = useState(0);

  // Auto rotate every 4s
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative bg-[#4E5C36] py-20 px-6 md:px-10 lg:px-20 overflow-hidden">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10">
        {/* Left Text */}
        <div
          className="text-white text-center lg:text-left"
          data-aos="fade-right"
          data-aos-delay="200"
        >
          <p className="uppercase tracking-widest text-sm mb-3">
            Meet the Chef
          </p>
          <h2 className="text-3xl lg:text-4xl font-semibold mb-4 favela">
            Chef Tandoh
          </h2>
          <p className="text-base md:text-lg text-gray-200 mb-6">
            Le Cordon Bleu trained with experience in Michelin-star kitchen
            teams including HIDE and Akoko, Chef Tandoh interprets the Marquess
            London brief - translating our house DNA into contemporary plates
            that favour balance, texture, and temperature over noise. Expect
            clean lines, layered flavour, and restraint: West African roots
            expressed with British sensibility and European finesse.
            <em>
              {" "}
              For this edition, he leads an intimate five-course service
              designed for conversation rather than theatre
            </em>
            .
          </p>
          {/* <button
            className="border border-white text-white py-2 px-6 hover:bg-white hover:text-[#4E5C36] transition"
            data-aos="zoom-in"
            data-aos-delay="400"
          >
            View All
          </button> */}
        </div>

        {/* Right Carousel */}
        <div className="flex flex-col items-center">
          <div className="relative flex items-center justify-center h-[320px] sm:h-[380px] md:h-[420px] lg:h-[500px] w-full">
            {images.map((img, index) => {
              const offset =
                (index - activeIndex + images.length) % images.length;

              let style =
                "absolute transition-all duration-700 rounded-lg shadow-lg";
              if (offset === 0) {
                // Active center (biggest)
                style +=
                  " w-56 sm:w-72 md:w-[22rem] lg:w-[28rem] scale-100 opacity-100 z-20 left-1/2 -translate-x-1/2";
              } else if (offset === 1) {
                // Next right
                style +=
                  " w-44 sm:w-60 md:w-[18rem] lg:w-[22rem] scale-95 opacity-80 z-10 left-[68%]";
              } else {
                // Last far right
                style +=
                  " w-36 sm:w-48 md:w-[14rem] lg:w-[18rem] scale-90 opacity-60 z-0 left-[83%]";
              }

              return (
                <img
                  key={index}
                  src={img}
                  alt={`Chef dish ${index + 1}`}
                  className={style}
                />
              );
            })}
          </div>

          {/* Indicators */}
          <div className="flex gap-2 mt-6">
            {images.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setActiveIndex(idx)}
                className={`w-3 h-3 rounded-full ${
                  idx === activeIndex
                    ? "bg-white"
                    : "bg-gray-400 hover:bg-gray-300"
                }`}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Bottom-left sketch */}
      <img
        src={person}
        alt="Person Illustration"
        className="absolute bottom-0 left-0 w-32 sm:w-40 md:w-48 lg:w-56 opacity-80"
        data-aos="fade-up-left"
        data-aos-delay="500"
      />
    </section>
  );
}
